import type { Alerts } from '@/common/composables/usePageData.ts'
import { isPlatformScriptConsoleEnabled } from '@/common/utils/scriptConsole'

export const useAlerts = () => {

  const displayAlerts = (alerts:Alerts[]): void => {
    if (!isPlatformScriptConsoleEnabled()) {
      return
    }
    alerts.forEach(alert => {
      console.log(`[${alert.variable_name}]: ${alert.text}`)
    })
  }

  return {
    displayAlerts
  }
}
